var _pattern, _path, _linearGradient, _path2, _path3, _linearGradient2, _path4, _path5, _linearGradient3, _path6, _path7, _linearGradient4, _path8, _path9, _defs, _clipPath, _path10, _g, _path11, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphone12Landscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "iphoneLandscape",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 877.9 435.5"
  }, props), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    x: 221.2,
    y: 656.7,
    width: 363,
    height: 730,
    patternUnits: "userSpaceOnUse",
    id: "iphone_12_landscape_svg__g",
    viewBox: "0 -730 363 730",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-730h363V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-730h363V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-730h363V0H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.4 11.2V1c0-.6.4-1 1-1h101.4c.6 0 1 .4 1 1v10.2c0 .6-.4 1-1 1H227.4c-.6 0-1-.5-1-1z",
    fill: "#12284a"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_landscape_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 463.586,
    y1: -1674.303,
    x2: 463.586,
    y2: -1701.075,
    gradientTransform: "matrix(0 -3.78 -3.78 0 -6100.998 1758.456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.6 11.2V1c0-.6.4-1 1-1h99.2c.6 0 1 .4 1 1v10.2c0 .6-.4 1-1 1h-99.2c-.5 0-1-.5-1-1z",
    fill: "url(#iphone_12_landscape_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.1 434.5v-10.2c0-.6.4-1 1-1h62.6c.6 0 1 .4 1 1v10.2c0 .6-.4 1-1 1h-62.6c-.6 0-1-.4-1-1z",
    fill: "#12284a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_landscape_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 444.726,
    y1: -1673.313,
    x2: 444.726,
    y2: -1689.821,
    gradientTransform: "matrix(0 -3.78 -3.78 0 -6119.517 2110.466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.4 434.5v-10.2c0-.6.4-1 1-1h60.4c.6 0 1 .4 1 1v10.2c0 .6-.4 1-1 1h-60.5c-.5 0-.9-.5-.9-1z",
    fill: "url(#iphone_12_landscape_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.3 434.5v-10.2c0-.6.4-1 1-1h62.6c.6 0 1 .4 1 1v10.2c0 .6-.4 1-1 1h-62.6c-.5 0-1-.5-1-1z",
    fill: "#12284a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_landscape_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 444.726,
    y1: -1677.063,
    x2: 444.726,
    y2: -1693.571,
    gradientTransform: "matrix(0 -3.78 -3.78 0 -6049.488 2110.466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289.6 434.5v-10.2c0-.6.4-1 1-1H351c.6 0 1 .4 1 1v10.2c0 .6-.4 1-1 1h-60.5c-.5 0-.9-.4-.9-1z",
    fill: "url(#iphone_12_landscape_svg__c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.2 434.5v-10.2c0-.5.4-1 1-1h31.6c.5 0 1 .4 1 1v10.2c0 .5-.4 1-1 1h-31.6c-.6 0-1-.4-1-1z",
    fill: "#12284a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_landscape_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 444.726,
    y1: -1670.463,
    x2: 444.726,
    y2: -1678.77,
    gradientTransform: "matrix(0 -3.78 -3.78 0 -6172.687 2110.466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4 434.5v-10.2c0-.5.4-1 1-1h29.4c.5 0 1 .4 1 1v10.2c0 .5-.4 1-1 1h-29.4c-.5 0-1-.4-1-1z",
    fill: "url(#iphone_12_landscape_svg__d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 70.8v293.9c0 37 30 66.9 66.9 66.9h742c37 0 66.9-30 66.9-66.9V70.9c0-37-30-66.9-66.9-66.9h-742C31.4 3.9 1.4 33.9 1.4 70.8zM812 24.5c25.3 0 45.8 20.5 45.8 45.8v294.9c0 25.3-20.5 45.8-45.8 45.8H66.6c-25.3 0-45.8-20.5-45.8-45.8v-35c0-5.4.5-8.1 9-8.1s22.8-5.3 22.8-24.1V137.5c0-18.8-14.4-24.1-22.8-24.1s-9-2.8-9-8.1v-35c0-25.3 20.5-45.8 45.8-45.8H812z",
    fill: "#969696"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "iphone_12_landscape_svg__e",
    d: "M0 365.1V71.3c0-37 30-66.9 66.9-66.9h742c37 0 66.9 30 66.9 66.9v293.8c0 37-30 66.9-66.9 66.9h-742C30 432.1 0 402.1 0 365.1z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "iphone_12_landscape_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iphone_12_landscape_svg__e",
    overflow: "visible"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 70.9V365.2c-.1 35.5 28.6 64.4 64.1 64.5H809c35.6.1 64.5-28.6 64.6-64.2V71.3c.1-35.5-28.6-64.4-64.2-64.6H66.9C31.4 6.6 2.5 35.4 2.4 70.9zM812 24.5c25.3 0 45.8 20.5 45.8 45.8v294.9c0 25.3-20.5 45.8-45.8 45.8H66.6c-25.3 0-45.8-20.5-45.8-45.8v-35c0-5.4.5-8.1 9-8.1s22.8-5.3 22.8-24.1V137.5c0-18.8-14.4-24.1-22.8-24.1s-9-2.8-9-8.1v-35c0-25.3 20.5-45.8 45.8-45.8H812z",
    clipPath: "url(#iphone_12_landscape_svg__f)",
    fill: "#142b4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#445b75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.8 90h14.4v9.8H.8zM782.2 411h9.8v21.2h-9.8zM88.2 411H98v21.2h-9.8zM88.2 3.3H98v21.2h-9.8zM782.2 3.3h9.8v21.2h-9.8zM865.5 335.7h12.4v9.8h-12.4z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 72v291.6c0 34.8 28.3 63 63.1 63h738.7c34.8 0 63.1-28.2 63.1-63.1V71.9c0-34.8-28.2-63.1-63.1-63.1H70C35.2 8.9 6.9 37.1 6.9 72zM812 24.5c25.3 0 45.8 20.5 45.8 45.8v294.9c0 25.3-20.5 45.8-45.8 45.8H66.6c-25.3 0-45.8-20.5-45.8-45.8v-35c0-5.4.5-8.1 9-8.1s22.8-5.3 22.8-24.1V137.5c0-18.8-14.4-24.1-22.8-24.1s-9-2.8-9-8.1v-35c0-25.3 20.5-45.8 45.8-45.8H812z",
    stroke: "#434343",
    strokeWidth: 0.5,
    strokeMiterlimit: 15.12
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32.4,
    cy: 174.9,
    r: 7.9,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.4,
    cy: 174.9,
    r: 4.9,
    fill: "#0a0d13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.4,
    cy: 174.9,
    r: 3.7,
    fill: "#091427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9 177.4c0 .5.7 1.1 2 1.1s2.1-.5 2.1-.9-2-1.6-4.1-.2zM29.4 174.3c.2.7 1.3.8 2 .8s2.3-.9 2-2c-.5-1-1.6-1.4-2.6-.9-.1 0-.1.1-.2.1-.9.3-1.6 1.2-1.2 2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#235a91",
    fillOpacity: 0.56
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("pattern", {
    id: "iphone_12_landscape_svg__h",
    xlinkHref: "#iphone_12_landscape_svg__g",
    patternTransform: "matrix(0 -1.5 -1.5 0 -29435.56 -25820.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9 235.6v-38.3c0-2.3 1.8-4.1 4.1-4.1 2.2 0 4 1.9 4 4.1v38.3c0 2.2-1.8 4-4 4.1-2.2 0-4.1-1.8-4.1-4.1z",
    fill: "url(#iphone_12_landscape_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9 235.6c-.1 2.3 1.6 4.2 3.9 4.3s4.2-1.6 4.3-3.9V197.3c.1-2.3-1.6-4.2-3.9-4.3s-4.2 1.6-4.3 3.9V235.6z",
    fill: "none",
    stroke: "#292929",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeMiterlimit: 14.91
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 239.1c.7 0 1.3.4 1.3.9s-.6.9-1.3.9c-.7 0-1.3-.4-1.3-.9s.6-.9 1.3-.9zM32 193.2c.7 0 1.3.4 1.3.9s-.6.9-1.3.9c-.7 0-1.3-.4-1.3-.9s.6-.9 1.3-.9z"
  })))));
}
export default SvgIphone12Landscape;